
const ReserveRequest = {
  "searchKey": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  "gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  "passengers": [
    {
      "firstName": "string",
      "lastName": "string",
      "seatNumber": 0,
      "nationalCode": "string",
      "gender": 1
    }
  ],
  "contact": {
    "name": "string",
    "mobilePhone": "string"
  }
  };
 

  export default ReserveRequest;
  